import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CompanyCommodity } from '@typeRoots/common/freight';
import { CheckListModalList } from '@typeRoots/common/checkListModal';

interface FreightState {
  companyCommodities: CompanyCommodity[]; // Company-specific commodities
  commodityList: CheckListModalList | null; // Full commodity list
  isCompanyCommoditiesSynced: boolean; // Tracks unsaved changes for company commodities
}

// Initial state
const initialState: FreightState = {
  companyCommodities: [],
  commodityList: null,
  isCompanyCommoditiesSynced: true, // Assume synced initially
};

// Create the slice
export const freightSlice = createSlice({
  name: 'freight',
  initialState,
  reducers: {
    // Set company commodities fetched from the backend
    setCompanyCommodities(state, action: PayloadAction<CompanyCommodity[]>) {
      state.companyCommodities = action.payload;
      state.isCompanyCommoditiesSynced = true; // Mark as synced
    },

    // Set the full commodity list fetched from the backend
    setCommodityList(state, action: PayloadAction<CheckListModalList>) {
      state.commodityList = action.payload;
    },
    clearCommodity(state) {
      state.companyCommodities = [];
      state.commodityList = null;
      state.isCompanyCommoditiesSynced = true;
    },
  },
});

// Export actions
export const { setCompanyCommodities, setCommodityList, clearCommodity } = freightSlice.actions;

// Export reducer
export default freightSlice.reducer;
